import { env } from "@/app/env";

const site_url = env.NEXT_PUBLIC_APP_URL;

export type SiteConfig = {
  name: string;
  description: string;
  url: string;
  ogImage: string;
  mailSupport: string;
  links: {
    twitter: string;
    github: string;
  };
};

export const siteConfig: SiteConfig = {
  name: "QuickNHS",
  description: "One place to track all NHS jobs. Get instant alerts for new NHS jobs in the UK.",
  url: site_url!,
  ogImage: `${site_url}/opengraph-image.png`,
  links: {
    twitter: "https://twitter.com/quicknhs",
    github: "https://github.com/quicknhs",
    // TODO : Add social media
  },
  mailSupport: "hello@quicknhs.com",
};
